import { AulaEditor } from '@ublend-npm/aula-editor';
import withFileBlocksValidation from './withFileBlocksValidation';
import withAnalytics from './withAnalytics';
import withErrorBoundary from '../ErrorBoundary/ErrorBoundary';

export default withErrorBoundary(
  withAnalytics(withFileBlocksValidation(AulaEditor)),
  { ignore: true }
);
